import { CookieYesConsentManager } from './consent/CookieYesConsentManager'
import { TrackingClient } from './TrackingClient'
import { Ga4Destination } from './destinations/Ga4Destination'
import { KissmetricsDestination } from './destinations/KissmetricsDestination'
import { CustomerIoDestination } from './destinations/CustomerIoDestination'
import { GoogleAdsDestination } from './destinations/GoogleAdsDestination'
import { FacebookPixelDestination } from './destinations/FacebookPixelDestination'
import { ZohoPageSenseDestination } from './destinations/ZohoPageSenseDestination'

let _client: TrackingClient | null = null

export function getTracking(): TrackingClient {
  if (_client) return _client

  // SSR-safe: return a client-like shim if needed.
  if (typeof window === 'undefined') {
    // @ts-expect-error - minimal shim
    return {
      identify: () => {},
      track: () => {},
      page: () => {},
      reset: () => {},
    }
  }

  const consentManager = new CookieYesConsentManager()

  _client = new TrackingClient({
    consentManager,
    destinations: [
      new KissmetricsDestination(),
      new Ga4Destination(),
      // Facebook Pixel (no GTM), gated by CookieYes marketing consent.
      new FacebookPixelDestination(),
      // Zoho PageSense (session recording/analytics), gated by CookieYes statistics consent.
      new ZohoPageSenseDestination(),
      // Existing integration on new site: Customer.io CDP is already installed; now it's routable.
      new CustomerIoDestination(),
      // Google Ads conversion tracking (Enhanced Conversions via hashed user_data), gated by marketing consent.
      new GoogleAdsDestination(),
    ],
    // Keep KM as primary and avoid surprising emissions; registry can widen per-event.
    defaultDestinations: ['kissmetrics'],
  })

  return _client
}

export const tracking = {
  identify: (...args: Parameters<TrackingClient['identify']>) =>
    getTracking().identify(...args),
  track: (...args: Parameters<TrackingClient['track']>) =>
    getTracking().track(...args),
  page: (...args: Parameters<TrackingClient['page']>) => getTracking().page(...args),
  reset: (...args: Parameters<TrackingClient['reset']>) => getTracking().reset(...args),
}


